import {getDocumentElement} from 'Utility/document';
import type {CssColor} from 'Catalyst/utility/theme';
import {get} from 'svelte/store';
import {whiteLabeling} from 'Store/WhiteLabelStore';
import {getContext} from 'svelte';

export const getBrandColor = (): CssColor => {
  const documentElement = getDocumentElement();
  const bgColor = getComputedStyle(documentElement)
    .getPropertyValue('--dm-bg-primary-color')
    .trim();
  if (bgColor) {
    return bgColor as CssColor;
  } else {
    return get(whiteLabeling).primary_color as CssColor;
  }
};

export const getCssProperty = (key: string) => {
  const themeProperty = getThemeCssProperty(key);
  if (themeProperty) {
    return themeProperty;
  }

  const documentElement = getDocumentElement();
  const bgColor = getComputedStyle(documentElement)
    .getPropertyValue(key)
    .trim();
  return bgColor;
};

export const getThemeCssProperty = (key: string) => {
  const theme = get(getContext('theme')) as Record<string, CssColor>;

  if (theme) {
    return theme[key];
  } else {
    return null;
  }
};
